

























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { HtmlImageContainer } from '@/models/Image';
import ImagePopup from '@/components/Inspiration/ImagePopup.vue';

@Component({
    components: {
        ImagePopup
    }
})
export default class RetailerExhibits extends Vue {
    protected exhibits!: HtmlImageContainer[];

    constructor() {
        super();
        this.exhibits = JSON.parse(this.$attrs['data-exhibits']);
       // console.log(this.exhibits);
        this.$attrs['data-exhibits'] = '';
    }
    private showImage(imageUrl: string) {
        this.$modal.show(
            ImagePopup,
            {
                imageUrl
            },
            {
                adaptive: false,
                height: '90%',
                width: '90%',
                maxWidth: 1500,
                scrollable: false
            }
        );
    }
}
